import { AppHelper } from 'helpers/appHelper';
import { useApiState } from 'hooks/useApiState';
import { useAppState } from 'hooks/useAppState';
import { useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';

export default function CommonWsLayoutNavbarLogout(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [acctState] = useRecoilState(AcctState);
  const { signOutRequest } = useAppState();
  const { handleSubmit } = useForm();
  const { postProxyLogout } = useApiState();
  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   *　編集リンククリック時の処理
   */
  const onSignOut = () => {
    AppHelper.submit(
      processing,
      setProcessing,
      handleSubmit(async () => {
        try {
          if (acctState.proxyLogin) {
            await postProxyLogout({});
            window.close();
          } else {
            await signOutRequest();
            navigate('/');
          }
        } catch (e) {
          showBoundary(e);
        }
      })
    );
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <div className="text-center">
      <a className="btn btn-logout" onClick={onSignOut}>
        <img src="/img/icon/logout.svg" alt="ログアウト" />
        ログアウト
      </a>
    </div>
  );
}
